import type { CircleLayer } from 'react-map-gl';

const MarkerFillLayer: CircleLayer = {
  id: 'marker-fill-layer',
  type: 'circle',
  paint: {
    'circle-radius': [
      'interpolate',
      ['linear'],
      ['get', 'count'],
      0,   10, 
      100, 20
    ],
    'circle-color': 'white'
  }
}

export { MarkerFillLayer }
